import authentication from './authentication';
import createProject from './create-project';
import parameters from './parameters';
import schedule from './schedule';
import screenerSessionAnswers from './screener-session-answer';
import templates from './templates';
import treeTest from './tree-test';
import notification from '../../tester/pages/account-settings/reducer';
import survey from './survey';

const rootReducer = ({
  authentication,
  createProject,
  parameters,
  schedule,
  screenerSessionAnswers,
  templates,
  treeTest,
  notification,
  survey,
});

export default rootReducer;
